import {ACTION_TYPE} from '../core/redux/actionType';
import {ResortMappingObject, RTPMappingProduct, SiriuswareMappingProduct} from './productMappings';
import {IAppState} from '../core/redux/IAppState';
import {assoc, sortByProp} from '../language/module';
import { sortByHydrationErrorsProp } from './hydrationErrors';


type SortProductsAction = {
  type: ACTION_TYPE.SORT_RESORT_MAPPING_PRODUCTS;
  payload: {
    sortBy: keyof RTPMappingProduct | keyof SiriuswareMappingProduct;
    sortAscending: boolean;
  };
}
/**
 * Creates an action that can be dispatched to sort resort mapping products by column
 * @param payload
 */
export const sortProductsAction = ( payload: SortProductsAction['payload'] ): SortProductsAction => ({
type: ACTION_TYPE.SORT_RESORT_MAPPING_PRODUCTS,
payload: payload,
})

export const sortProductsReducer = (state: IAppState, action: SortProductsAction): IAppState => {

  const productToSortBy = action.payload;

  if (!productToSortBy || action.type !== 'SORT_RESORT_MAPPING_PRODUCTS') return state;

  const products = state.resortMappingHistories.productMappings;

  const sortedProductMappings = productToSortBy.sortBy === 'hydrationErrors' ?
    sortByHydrationErrorsProp(productToSortBy.sortAscending, products) :
    sortByProp(productToSortBy.sortBy, true, productToSortBy.sortAscending, products);

  // A new array every time would loop DynamicTable, which re-sorts on every row change
  if (sortedProductMappings.every((row, index) => row === products[index])) return state;

  const newObj: ResortMappingObject = {
    posProvider: state.resortMappingHistories.posProvider,
    productMappings: sortedProductMappings,
    hasError: state.resortMappingHistories.hasError
  }

  return assoc(
    'resortMappingHistories',
    newObj,
    state,
  )
}
